/* ============================================================
   Quote builder
   Merged from LStorage.ts / Display.ts / ProductSelector.ts /
   QuoteHandler.ts into one file, no build step.

   The three-class inheritance chain collapsed into one object:
   they shared all their state anyway, so the layering only
   added indirection.
   ============================================================ */

(function () {
  "use strict";

  var STORAGE_KEY = "qb";
  var ENDPOINT = "https://hub.thesaunaheater.com";

  var $ = function (sel, root) {
    return (root || document).querySelector(sel);
  };

  /* ---------------------------------------------------------
     State
     --------------------------------------------------------- */
  function blankQuote() {
    return {
      sent: false,
      products: [],
      customer: { name: "", email: "", phone: "", location: "", message: "" },
    };
  }

  function loadQuote() {
    try {
      var stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
      if (!stored || typeof stored !== "object") return blankQuote();

      /* Merge onto a blank so a stale or partial shape can't
         crash us later with an undefined .customer */
      var base = blankQuote();
      return {
        sent: !!stored.sent,
        id: stored.id,
        products: Array.isArray(stored.products) ? stored.products : [],
        customer: Object.assign(base.customer, stored.customer),
      };
    } catch (e) {
      return blankQuote();
    }
  }

  var quote = loadQuote();

  function isBlank() {
    return (
      quote.products.length === 0 &&
      !quote.customer.email &&
      !quote.customer.name
    );
  }

  function save() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(quote));
    } catch (e) {
      /* private mode / quota — the form still works this session */
    }
    renderProducts();
  }

  /* ---------------------------------------------------------
     Rendering
     --------------------------------------------------------- */
  function renderProducts() {
    var list = document.getElementById("qb-product-list");
    if (!list) return;

    list.innerHTML = "";

    if (quote.products.length === 0) {
      var row = document.createElement("tr");
      row.className = "qb__empty-list";
      var cell = document.createElement("td");
      cell.colSpan = 3;
      cell.textContent = "No products added yet";
      row.appendChild(cell);
      list.appendChild(row);
      return;
    }

    var template = document.getElementById("qb-product-template");

    quote.products.forEach(function (p) {
      var clone = template.content.cloneNode(true);
      $(".qb-title", clone).textContent = p.title;
      $(".qb-qty-indicator", clone).textContent = "\u00d7 " + p.quantity;
      $(".qb__remove-button", clone).dataset.id = p.id;
      list.appendChild(clone);
    });
  }

  /* ---------------------------------------------------------
     Products
     --------------------------------------------------------- */
  function addProduct(id, qty) {
    if (
      quote.products.some(function (p) {
        return p.id === id;
      })
    )
      return;

    var meta =
      window.ShopifyAnalytics && window.ShopifyAnalytics.meta.product.variants;
    var variant =
      meta &&
      meta.find(function (v) {
        return String(v.id) === String(id);
      });
    if (!variant) return;

    quote.products.push({
      id: String(variant.id),
      title: variant.name,
      quantity: Number(qty) || 1,
    });
    save();
  }

  function removeProduct(id) {
    quote.products = quote.products.filter(function (p) {
      return p.id !== id;
    });
    save();
  }

  /* ---------------------------------------------------------
     Validation
     --------------------------------------------------------- */
  function setFieldError(input, hasError) {
    var field = input.closest(".field");
    if (field) field.classList.toggle("field--error", hasError);
    if (hasError) input.setAttribute("aria-invalid", "true");
    else input.removeAttribute("aria-invalid");
  }

  function validate(inputs, feedback) {
    var valid = true;

    inputs.forEach(function (input) {
      var bad = input.required && !input.value.trim();
      setFieldError(input, bad);
      if (bad) valid = false;
    });

    if (quote.products.length === 0) {
      feedback.textContent =
        'Click "Add" to put a product on the quote request.';
      valid = false;
    } else {
      feedback.textContent = "";
    }

    return valid;
  }

  /* ---------------------------------------------------------
     Submit
     --------------------------------------------------------- */
  function googleClickId() {
    var names = ["_gcl_aw=", "_gbraid=", "_wbraid="];
    var cookies = document.cookie.split(";").map(function (c) {
      return c.trim();
    });

    for (var i = 0; i < names.length; i++) {
      var hit = cookies.find(function (c) {
        return c.indexOf(names[i]) === 0;
      });
      if (hit) return hit.split("=")[1];
    }
    return null;
  }

  /* ---------------------------------------------------------
     Init
     --------------------------------------------------------- */
  function init() {
    var form = document.getElementById("qb-form");
    var container = document.getElementById("qb-container");
    if (!form || !container) return; /* not on this page — nothing to do */

    var variant = document.getElementById("variant-selector");
    var quantity = document.getElementById("quantity");
    var feedback = document.getElementById("qb__feedback");
    var submit = document.getElementById("qb-submit");

    var inputs = ["name", "email", "location", "phone", "message"]
      .map(function (id) {
        return document.getElementById(id);
      })
      .filter(Boolean);

    /* --- Restore saved answers ---------------------------- */
    inputs.forEach(function (input) {
      if (quote.customer[input.name]) input.value = quote.customer[input.name];
    });

    renderProducts();

    if (!isBlank()) container.dataset.status = "open";
    if (quote.sent) container.dataset.status = "sent";

    /* --- One delegated click handler for the whole widget --- */
    container.addEventListener("click", function (e) {
      var el = e.target.closest("button");
      if (!el) return;

      switch (el.id) {
        case "qb__rq-button":
          container.dataset.status = "open";
          form.scrollIntoView({ behavior: "smooth", block: "center" });
          return;

        case "qb-back":
          container.dataset.status = "closed";
          return;

        case "qty-plus":
          quantity.value = String(Number(quantity.value) + 1);
          return;

        case "qty-minus":
          quantity.value = String(Math.max(1, Number(quantity.value) - 1));
          return;

        case "qb-add-button":
          addProduct(variant.value, quantity.value);
          return;

        case "qb-submit":
          if (validate(inputs, feedback)) send();
          return;
      }

      if (el.classList.contains("qb__remove-button")) {
        removeProduct(el.dataset.id);
      }
    });

    /* --- Persist answers as they're typed ------------------ */
    var saveTimer;
    container.addEventListener("input", function (e) {
      var input = e.target;
      if (!input.name || !(input.name in quote.customer)) return;

      quote.customer[input.name] = input.value;
      if (input.hasAttribute("aria-invalid")) setFieldError(input, false);

      clearTimeout(saveTimer);
      saveTimer = setTimeout(save, 300);
    });

    /* --- Send ---------------------------------------------- */
    function send() {
      submit.dataset.state = "loading";
      var fullPackage = document.getElementById("quote-fp");

      fetch(ENDPOINT + "/api/quote", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          sent: quote.sent,
          products: quote.products,
          customer: quote.customer,
          shop: window.Shopify.shop,
          click_id: googleClickId(),
          full_package: fullPackage && fullPackage.checked ? true : null,
        }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error(res.status);
          quote.sent = true;
          save();
          container.dataset.status = "sent";
          $(".qb__sent-container").scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        })
        .catch(function () {
          feedback.textContent =
            "We couldn't send your request. Please try again, or contact us directly.";
        })
        .finally(function () {
          submit.dataset.state = "idle";
        });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
